<template>
  <div class="input-container">
    <label
      v-if="!inputFocused && !data"
      class="v-label"
      style="left: 12px; top: 10px; position: absolute; pointer-events: none; color: #00000099"
      :class="{ 'error--text': !!errorText }"
      >{{ label || 'HH:mm' }}
    </label>
    <MaskedInput
      v-bind="this.$attrs"
      v-model="data"
      mask="11:11"
      class="input"
      @focus.native="inputFocused = true"
      @blur.native="inputFocused = false"
      :class="{ 'input--error': !!errorText }"
    />
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import MaskedInput from 'vue-masked-input'
import VInput from 'vuetify/lib/components/VInput/VInput.js'

export default {
  extends: VInput,
  components: {
    MaskedInput,
  },
  props: {
    date: String,
    label: String,
    returnTime: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    data: '',
    menu: false,
    errorText: '',
    isRule: false,
    inputFocused: false,
  }),

  methods: {
    validate(force) {
      // overide validate VInput
      if (force) {
        this.updated(this.data)
      }
      return !this.errorText
    },
    setIsRule(status) {
      this.isRule = status
    },
    updated(value) {
      if (value === '__:__') value = ''
      if (this.rules && this.rules.length && this.isRule) {
        let errorText = ''
        for (const rule of this.rules) {
          errorText = rule(value)
          if (errorText !== true) break
        }
        if (errorText !== true) this.errorText = errorText
        else this.errorText = null
      }
      if (value) {
        if (!this.errorText) {
          this.$emit('update:date', value)
        }
      } else {
        this.$emit('update:date', '')
      }
      this.menu = false
    },
    reset() {
      this.data = ''
    },
  },
  created() {
    this.reset()
  },
  watch: {
    isRule() {
      if (!this.isRule) {
        this.errorText = ''
      }
    },
    data(value) {
      if (value.length === 5) {
        this.isRule = true
        this.updated(this.data)
      }
    },
    date(value) {
      if (value) {
        this.data = value
      } else {
        this.data = ''
        this.updated('')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
}
.input {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
  padding: 7px 8px;
  box-sizing: border-box;
}

.input:focus {
  border: 2px solid #0d47a1;
  padding: 6px 7px;
}

.input--error {
  border: 2px solid #b71c1c !important;
  padding: 6px 7px;
}
.error-text {
  margin-top: 4px;
  min-height: 14px;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
}
</style>
